import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsertionDirective } from './insertion.directive';
import {ModalConfig} from './modal-config';
import { ConfirmComponent } from './confirm/confirm.component';
import {ModalComponent} from './modal.component';

@NgModule({
    imports: [
        CommonModule,
        ModalComponent,
        InsertionDirective,
        ConfirmComponent
    ],
    providers: [
        ModalConfig
    ]
})
export class ModalModule { }
